import { writable, type Writable } from 'svelte/store';

// This is to mock the top-layer logic until we get a direct access to it natively
export const dialogs: Writable<HTMLDialogElement[]> = writable([]);

// This is used to handle the drawer stacking animation
export const drawers: Writable<(HTMLDialogElement | string)[]> = writable([]);
